var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { AlertDialog } from '@homeexchange/design';
import { getResolutionCenterToken } from '../../api/Exchange';
import i18n from '../../i18n';
import { Button } from '@homeexchange/design';
var redirectToResolutionCenter = function (token) {
    var hotfixEnv = process.env.URL_RESOLUTION_CENTER_HOTFIX;
    var resolutionCenterUrl = localStorage.getItem('use-resolution-center-hotfix-environment') === 'true' && hotfixEnv
        ? hotfixEnv
        : process.env.URL_RESOLUTION_CENTER;
    var form = document.createElement('form');
    form.setAttribute('action', "".concat(resolutionCenterUrl, "/auth/session/from-he-website"));
    form.setAttribute('method', 'post');
    form.setAttribute('target', '_blank');
    var input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'token');
    input.setAttribute('value', token);
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};
export var ResolutionCenterButton = function (_a) {
    var conversationId = _a.conversationId, isFullWidth = _a.isFullWidth;
    var _b = useState(false), displayModal = _b[0], setDisplayModal = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { hierarchy: "secondary", isLoading: isLoading, isDisabled: isLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                var resolutionCenterToken, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setIsLoading(true);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, getResolutionCenterToken(typeof conversationId === 'string'
                                    ? parseInt(conversationId, 10)
                                    : conversationId, localStorage.getItem('use-resolution-center-hotfix-environment') === 'true')];
                        case 2:
                            resolutionCenterToken = _a.sent();
                            redirectToResolutionCenter(resolutionCenterToken.token);
                            return [3 /*break*/, 5];
                        case 3:
                            err_1 = _a.sent();
                            setDisplayModal(true);
                            return [3 /*break*/, 5];
                        case 4:
                            setIsLoading(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); }, isFullWidth: isFullWidth }, i18n.t('exchange:global_declareAnIncident')),
        React.createElement(AlertDialog, { isOpen: displayModal, iconStatus: "error", title: i18n.t('exchange:modal_resolutionCenter_error_title'), confirmActionText: i18n.t('common:global.close'), onConfirmAction: function () { return setDisplayModal(false); } }, i18n.t('exchange:modal_resolutionCenter_error_body'))));
};
